<template lang="html">
  <div class="row-edit no-margin track">
    <div class="row-edit-badge-section">
      <div class="row-edit-badge">
          <div class="float-left w220">
            <div>
              <label>{{$t('INDENT_REQUESTED_FREIGHT_CHANGE_REQUESTED')}}</label>
              <span class="track-text">{{getNewFreightRate}}</span>
            </div>
          </div>
        </div>
    </div>

    <div class="popover-primary-footer">
      <div class="action">
        <button class="btn-primary accept" @click="$emit('accept')">
          {{$t('INDENT_ACCEPT')}}
        </button>
        <button class="btn-primary accept" @click="$emit('reject')">
          {{$t('INDENT_REJECT')}}
        </button>
      </div>
    </div>

  </div>
</template>
<script>
import { contractTypes } from '@/constants/indentConstants';

export default {
  name: 'FreightChangeRequest',
  props: {
    order: Object,
  },
  data() {
    return {
      contractTypes,
    };
  },
  computed: {
    getNewFreightRate() {
      const freightRate = this.order.change_freight_rate;
      const freightUnit = this.contractTypes.filter(type =>
        type.id === this.order.change_freight_unit)[0].name;
      return `${freightRate}/${freightUnit}`;
    },
  },
};
</script>
